@if (!isError && !isLoading) {
  <ng-container *transloco="let convert;">
    <div
      class="modal--action-list"
      role="dialog"
      aria-modal="true"
      aria-labelledby="make-reserve-modal-title"
      [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeUnreserveModal.ariaLabelMakeUnreserveModal')"
      [attr.data-track-region]="textHeader"
      >
      <header class="modal__header">
        <h1 class="modal__title" id="make-reserve-modal-title" tabindex="-1">
          {{ textHeader }}
        </h1>
      </header>
      <div class="modal__content">
        <div
          class="modal__body"
          [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeUnreserveModal.ariaLabelUnreserve')">
          <label>{{textSubHeader}}</label>
          <div class="vehicle-info__row">
          </div>
        </div>
        <div class="modal__actions">
          <button
            class="btn btn-primary me-md-2 mb-3 mb-md-0"
            data-track-elem="button"
            data-track-name="Search"
            allytmln="Unreserve"
            [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeUnreserveModal.ariaLabelUnreserve')"
            (click)="makeUnreserve()"
            [disabled]="isIsvFileProcessing"
          >
            {{convert('sellModule.manageInventory.actionListModal.makeUnreserveModal.ariaLabelUnreserve')}}
          </button>
          <button
            class="btn cancel btn-link outline-focus ms-md-2"
            allytmln="Cancel"
            [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeUnreserveModal.ariaLabelCancel')"
            (click)="closeModal()">
            <span>{{convert('sellModule.manageInventory.actionListModal.makeUnreserveModal.ariaLabelCancel')}}</span>
          </button>
        </div>
      </div>
      @if (configuration) {
        <button
          class="modal__close"
          data-dismiss="modal"
          [attr.aria-label]="convert('common.modalClose')"
          (click)="closeModal()"
          data-track-elem="icon"
          data-track-name="Close"
          data-track-trigger="close">
          <img
            src="../../../../../ui/assets/assets-{{ configuration.tenantName }}/{{ configuration.tenantName }}-close.svg"
            alt="{{convert('common.altCloseModelIcon')}}"/>
        </button>
      }
    </div>
  </ng-container>
}
@if (isLoading) {
  <div class="spinner-container">
    <app-spinner></app-spinner>
  </div>
}
@if (isError) {
  <div class="error-container">
    <button
      id="error-close"
      class="error__close"
      aria-label="Close modal"
      (click)="closeModal()"
      (keydown.escape)="closeModal()"
      data-track-elem="icon"
      data-track-name="close"
      data-track-trigger="close"
      >
      <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
    </button>
    <div class="content text-center">
      <span class="text-danger" aria-hidden="true"><app-error-icon fill="currentColor"></app-error-icon></span>
      <p>{{textError}}</p>
    </div>
  </div>
}

<ng-template #spinner>
  <div class="spinner-container">
    <app-spinner></app-spinner>
  </div>
</ng-template>

<ng-template #error>
  <div class="error-container">
    <button
      id="error-close"
      class="error__close"
      aria-label="Close modal"
      (click)="closeModal()"
      (keydown.escape)="closeModal()"
      data-track-elem="icon"
      data-track-name="close"
      data-track-trigger="close"
      >
      <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
    </button>
    <div class="content text-center">
      <span class="text-danger" aria-hidden="true"><app-error-icon fill="currentColor"></app-error-icon></span>
      <p>{{textError}}</p>
    </div>
  </div>
</ng-template>

<ng-template #makeUnreserveModal>
  <ng-container *transloco="let convert;">
    <div
      class="modal--action-list"
      role="dialog"
      aria-modal="true"
      aria-labelledby="make-reserve-modal-title"
      [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeUnreserveModal.ariaLabelMakeUnreserveModal')"
      [attr.data-track-region]="textHeader"
      >
      <header class="modal__header">
        <h1 class="modal__title" id="make-reserve-modal-title" tabindex="-1">
          {{ textHeader }}
        </h1>
      </header>

      <div class="modal__content">
        <div
          class="modal__body"
          [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeUnreserveModal.ariaLabelUnreserve')">
          <label>{{textSubHeader}}</label>
          <div class="vehicle-info__row">
          </div>
        </div>

        <div class="modal__actions">
          <button
            class="btn btn-primary me-md-2 mb-3 mb-md-0"
            data-track-elem="button"
            data-track-name="Search"
            allytmln="Unreserve"
            [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeUnreserveModal.ariaLabelUnreserve')"
            (click)="makeUnreserve()"
            [disabled]="isIsvFileProcessing"
          >
            {{convert('sellModule.manageInventory.actionListModal.makeUnreserveModal.ariaLabelUnreserve')}}
          </button>
          <button
            class="btn cancel btn-link outline-focus ms-md-2"
            allytmln="Cancel"
            [attr.aria-label]="convert('sellModule.manageInventory.actionListModal.makeUnreserveModal.ariaLabelCancel')"
            (click)="closeModal()">
            <span>{{convert('sellModule.manageInventory.actionListModal.makeUnreserveModal.ariaLabelCancel')}}</span>
          </button>

        </div>
      </div>

      @if (configuration) {
        <button
          class="modal__close"
          data-dismiss="modal"
          [attr.aria-label]="convert('common.modalClose')"
          (click)="closeModal()"
          data-track-elem="icon"
          data-track-name="Close"
          data-track-trigger="close">
          <img
            src="../../../../../ui/assets/assets-{{ configuration.tenantName }}/{{ configuration.tenantName }}-close.svg"
            alt="{{convert('common.altCloseModelIcon')}}"/>
        </button>
      }
    </div>
  </ng-container>
</ng-template>
